import { render, staticRenderFns } from "./endActivity.vue?vue&type=template&id=2a8e71c3&scoped=true&lang=html&"
import script from "./endActivity.vue?vue&type=script&lang=js&"
export * from "./endActivity.vue?vue&type=script&lang=js&"
import style0 from "./endActivity.vue?vue&type=style&index=0&id=2a8e71c3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8e71c3",
  null
  
)

export default component.exports